import React from 'react';
import { CheckCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { whyChooseUs } from '../mock';

const WhyChooseUs = () => {
  const { language } = useLanguage();
  const reasons = whyChooseUs[language];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-950 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="1"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'
      }}></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            {language === 'en' 
              ? 'A Legacy of Protection, Powered by Community'
              : 'Un Legado de Protección, Impulsado por la Comunidad'}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason) => (
            <div
              key={reason.id}
              className="bg-white/10 backdrop-blur-md rounded-xl p-8 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2 border border-white/20"
            >
              <CheckCircle className="w-12 h-12 text-blue-300 mb-4" />
              <h3 className="text-xl font-bold mb-3">{reason.title}</h3>
              <p className="text-blue-100 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        {/* BusinessRate Recognition Badge */}
        <div className="mt-12 text-center">
          <div className="inline-block bg-gradient-to-r from-yellow-500 to-amber-500 rounded-2xl p-6 shadow-2xl transform hover:scale-105 transition-all duration-300">
            <div className="flex flex-col items-center gap-3">
              <div className="flex items-center gap-2">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <span className="text-white text-2xl font-bold">Top 3</span>
              </div>
              <div className="text-white text-center">
                <p className="text-sm font-semibold">
                  {language === 'en' ? '2026 Insurance Agency' : 'Agencia de Seguros 2026'}
                </p>
                <p className="text-xs">Frisco, TX 75036</p>
                <p className="text-xs mt-1 opacity-90">
                  {language === 'en' ? 'Recognized by BusinessRate' : 'Reconocido por BusinessRate'}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 md:p-12 inline-block border border-white/20">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              {language === 'en'
                ? 'Coverage You Can Count On'
                : 'Cobertura en la que Puede Confiar'}
            </h3>
            <p className="text-lg text-blue-100 mb-6 max-w-2xl">
              {language === 'en'
                ? 'Through Palerm Insurance agents and financial advisors, we are committed to helping you build & protect your assets. Let us work with you as you plan your future & care for the people & things that matter the most.'
                : 'A través de los agentes y asesores financieros de Palerm Insurance, estamos comprometidos a ayudarlo a construir y proteger sus activos. Permítanos trabajar con usted mientras planifica su futuro y cuida de las personas y cosas que más importan.'}
            </p>
            <button className="bg-white text-blue-900 px-8 py-4 rounded-full text-lg font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              {language === 'en' ? 'Contact Us Today' : 'Contáctenos Hoy'}
            </button>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-32 h-32 bg-blue-400/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-40 h-40 bg-blue-600/10 rounded-full blur-3xl"></div>
    </section>
  );
};

export default WhyChooseUs;